import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../../redux/services/apiPath";
import authHeader from "../../../redux/services/authHeader";

const validationSchema = Yup.object().shape({
  bankName: Yup.string().required("Bank Name Is Required"),
  accountNumber: Yup.string().required("Account Numnber Is Required"),
  ifscCode: Yup.string().required("Ifsc Code Is Required"),
  branchName: Yup.string().required("Branch Name Is Required"),
  accountHolder: Yup.string().required("Account Holder Name Is Required"),
});

const defaultValues = {
  bankName: "",
  accountNumber: "",
  ifscCode: "",
  branchName: "",
  accountHolder: "",
  image: "",
};

const OutletBankDetailsModal = ({ outletId, onHide, ...props }) => {
  const [initialValues, setInitialValues] = useState(defaultValues);
  const [image, setImage] = useState("");

  const getBankDetails = async () => {
    if (!outletId) {
      setInitialValues(defaultValues);
      setImage("");
      return;
    }

    const res = await axios.post(
      `${BASE_URL}outlet/getOutletBankDetail`,
      { outletId },
      authHeader(),
    );

    if (res?.data?.status == "success") {
      const bankData = res?.data?.data || {};
      setInitialValues({
        bankName: bankData?.bankName || "",
        accountNumber: bankData?.accountNumber || "",
        ifscCode: bankData?.ifscCode || "",
        branchName: bankData?.branchName || "",
        accountHolder: bankData?.accountHolder || "",
        image: bankData?.image || "",
      });
      setImage(bankData?.image || "");
    } else {
      setInitialValues(defaultValues);
      setImage("");
    }
  };

  useEffect(() => {
    getBankDetails();
  }, [outletId]);

  const imageUpdload = async (e, setFieldValue) => {
    const selectedImage = e.target.files[0];

    if (!selectedImage) {
      return;
    }

    const formdata = new FormData();
    formdata.append("image", selectedImage);
    const res = await axios.post(
      `${BASE_URL}outlet/uploadImage`,
      formdata,
      authHeader(),
    );

    if (res?.data?.status == "success") {
      const uploadedImage = res?.data?.data?.[0] || "";
      toast.success("Image Uploaded Successfully");
      setImage(uploadedImage);
      setFieldValue("image", uploadedImage);
    } else {
      toast.error("Something Went Wrong ");
    }
  };

  const handleSubmit = async (values) => {
    const data = {
      outletId: outletId || "",
      bankDetail: {
        ...values,
        image: image || values.image || "",
      },
    };

    const res = await axios.post(
      `${BASE_URL}outlet/updateOutletBankDetail`,
      data,
      authHeader(),
    );

    if (res?.data?.status == "success") {
      toast.success("Bank Updated Successfully");
      if (onHide) {
        onHide();
      }
    } else {
      toast.error("Something Went Wrong ");
    }
  };

  return (
    <Modal
      {...props}
      onHide={onHide}
      size="lg"
      aria-labelledby="outlet-bank-details-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="outlet-bank-details-modal">
          <h6>Outlet Bank Details</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <div className="ms-panel ms-panel-fh">
              <div className="ms-panel-header">
                <h6>Update bank details for this outlet.</h6>
              </div>
              <div className="ms-panel-body">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {(formik) => (
                    <Form className="needs-validation clearfix" noValidate>
                      <div className="form-row">
                        <div className="col-md-12 mb-3">
                          <label htmlFor="bankName">
                            Bank Name<span className="error">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control ${
                              formik.errors.bankName && formik.touched.bankName
                                ? "is-invalid"
                                : ""
                            }`}
                            id="bankName"
                            name="bankName"
                            placeholder="Bank Name"
                          />
                          <ErrorMessage
                            name="bankName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label htmlFor="accountNumber">
                            Account Number<span className="error">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control ${
                              formik.errors.accountNumber &&
                              formik.touched.accountNumber
                                ? "is-invalid"
                                : ""
                            }`}
                            id="accountNumber"
                            name="accountNumber"
                            placeholder="Account Number"
                          />
                          <ErrorMessage
                            name="accountNumber"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label htmlFor="ifscCode">
                            IFSC Code<span className="error">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control ${
                              formik.errors.ifscCode && formik.touched.ifscCode
                                ? "is-invalid"
                                : ""
                            }`}
                            id="ifscCode"
                            name="ifscCode"
                            placeholder="IFSC Code"
                          />
                          <ErrorMessage
                            name="ifscCode"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label htmlFor="branchName">
                            Branch Name<span className="error">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control ${
                              formik.errors.branchName &&
                              formik.touched.branchName
                                ? "is-invalid"
                                : ""
                            }`}
                            id="branchName"
                            name="branchName"
                            placeholder="Branch Name"
                          />
                          <ErrorMessage
                            name="branchName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label htmlFor="accountHolder">
                            Account Holder Name<span className="error">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control ${
                              formik.errors.accountHolder &&
                              formik.touched.accountHolder
                                ? "is-invalid"
                                : ""
                            }`}
                            id="accountHolder"
                            name="accountHolder"
                            placeholder="Name"
                          />
                          <ErrorMessage
                            name="accountHolder"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label htmlFor="image">
                            Image<span className="error">*</span>
                          </label>
                          <input
                            type="file"
                            className={`form-control ${
                              formik.errors.image && formik.touched.image
                                ? "is-invalid"
                                : ""
                            }`}
                            id="image"
                            onChange={(e) =>
                              imageUpdload(e, formik.setFieldValue)
                            }
                            placeholder="Image"
                          />
                          <ErrorMessage
                            name="image"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OutletBankDetailsModal;
